<template>
  <div class="upload-image-box">
    <div class="upload-thumbnail">
      <viewer v-if="thumbnail" class="preview-image">
        <img :src="thumbnail" />
      </viewer>
      <i v-else class="el-icon-picture"></i>
    </div>
    <div class="upload-content">
      <p>{{ uploadTip }}</p>
      <page-upload
        ref="uploadRef"
        :showFileList="false"
        :fileList="fileList"
        :accept="'image/*'"
        :showTip="false"
        :attr="buttonAttr"
        @uploadSuccess="uploadSuccess"
      ></page-upload>
    </div>
  </div>
</template>

<script>
import pageUpload from "@/components/page-upload.vue";
export default {
  name: "UploadImage",
  inheritAttrs: true,
  components: { pageUpload },
  props: {
    uploadTip: {
      default: "支持/JPG/PNG/GIF格式，大小不超过1M，建议尺寸750*400px",
    },
    value: {
      default: "",
    },
  },
  data: function () {
    return {
      thumbnail: "",
      fileList: [],
      buttonAttr: { type: "primary", round: true },
    };
  },

  methods: {
    uploadSuccess() {
      this.thumbnail = this.fileList[0].thumbnail;
      this.$emit("input", this.fileList[0].thumbnail);
      this.fileList = [];
      this.$refs.uploadRef.$refs.uploadRef.clearFiles();
    },
  },
  watch: {
    value: {
      handler(_new) {
        this.thumbnail = _new;
      },
      immediate: true,
    },
  },
  computed: {},
};
</script>
<style scoped lang="scss">
.upload-image-box {
  display: flex;
  align-items: center;
  width: 100%;
  padding: 16px;
  border: 1px solid #e6e6e6;
  border-radius: 3px;
}
.upload-thumbnail {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 200px;
  height: 140px;
  background-color: #ececec;
  border-radius: 3px;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  i {
    font-size: 50px;
    color: #d7d7d7;
  }
}
.preview-image {
  width: 100%;
  height: 100%;
}
.upload-content {
  margin-left: 20px;
  width: calc(100% - 220px);

  p {
    margin-bottom: 20px;
    font-size: 13px;
    color: #bcc0c4;
    line-height: normal;
  }
}
</style>